import { IdentityInfo } from './IdentityInfo';
import { CustomerInfo } from './CustomerInfo';
import { UserContact } from './UserContact';
import { useState, } from 'react';
import { TextField, Button, Switch, FormControlLabel, FormGroup, CircularProgress } from '@material-ui/core';
import { transferUserData, archiveUserData, deleteSibNumber } from './index';
import { useNotify } from "react-admin";
export const validateIranMobile = (value: any): any => {
    const regex = /^09\d{9}$/;
    if (value) {
        if (!regex.test(value)) {
            return "شماره موبایل صحیح نمیباشد";
        }
        return '';
    }
};

export function RowTable(props: any) {
    let allDietTypes = props.allDietTypes;
    let relationTypes = props.relationTypes;
    let item = props.item;
    let mainIdentityId = props.mainIdentityId;
    let refetch = props.refetch;
    const [transferMobile, setTransferMobile] = useState<any>('');
    const [transferError, setTransferError] = useState<string>('');
    const [checkedState, setCheckedState] = useState<any>(false);
    const [titleState, setTitleState] = useState<any>(false);
    const [selectedDiets, setSelectedDiets] = useState<any>([]);
    const [loadingRow, setLoadingRow] = useState<any>(false);
    const notify = useNotify()
    const handleTransferInputChange = async (event: any) => {
        const { value } = event.target;
        setTransferMobile(value);
        setTransferError(validateIranMobile(value));
    };
    const handleSelectedDietsChange = (selectedDiets: any) => {
        setSelectedDiets(selectedDiets);
    };
    const checkisArchived = () => {
        return item.customers.some((user: any) => {
            return user.diets && user.diets.some((diet: any) => {
                return selectedDiets.includes(diet.id) && diet.sid.endsWith("-old");
            });
        });
    };
    const checkUnArchivable = () => {
        return item.customers.some((user: any) => {
            return user.diets && user.diets.some((diet: any) => {
                return !diet.sid.endsWith("-old") && selectedDiets.includes(diet.id)
            });
        });
    };

    const checkDisablityArchive = () => {
        checkisArchived();
        if (checkedState) {
            return false
        } else {
            if (selectedDiets.length > 0) {
                return false
            } else {
                return true
            }
        }
    }
    const checkDisablity = () => {
        if (checkedState) {

            if (!transferError && transferMobile) {
                return false
            } else {
                return true
            }
        } else {
            if (selectedDiets.length > 0) {

                if (!transferError && transferMobile) {
                    return false
                } else {
                    return true
                }
            } else {

                return true
            }
        }
    }
    const archive = async (e: any, archiveState: any) => {
        e.preventDefault()
        let serverData = {
            sid: item.sid,
            identityId: item.id,
            dietIds: selectedDiets,
            isArchived: archiveState
        }

        if (checkedState) {
            delete serverData.dietIds
        } else {
            if (selectedDiets.length <= 0) {
                return
            } else {
                delete serverData.identityId
            }
        }

        try {
            setLoadingRow(true)
            const response = await archiveUserData(serverData)
            if (response.data.err) {

                notify(` کد${response.data.err.code} - ${response.data.err.details.messages[0]}`)
                setLoadingRow(false)
            } else {
                refetch()
                setCheckedState(false)
                setSelectedDiets([])
                setLoadingRow(false)
            }
        } catch (error) {
            setLoadingRow(false)
            notify(`خطایی پیش آمده است`)
        }
    }
    const refetchChild = () => {
        refetch()
    }
    const deleteSibProfileNumber = async (e: any) => {
        e.preventDefault()
        let customerId = item.customers[0]?.id || null;
        if (customerId) {
            setLoadingRow(true)
            try {

                const response = await deleteSibNumber(customerId)
                if (response.data && response.data.err) {
                    setLoadingRow(false)
                    notify(` کد${response.data.err.code} - ${response.data.err.details.messages[0]}`)

                } else {
                    refetch()
                    setLoadingRow(false)
                    notify(` با موفقیت حذف شد  `)
                }

            } catch (error) {
                setLoadingRow(false)
                notify(`خطایی پیش آمده است`)
            }
        } else {
            notify(`شماره پرونده موجود نیست   `)
        }

    }
    const transfer = async (e: any) => {
        e.preventDefault()
        if (!transferError && transferMobile) {

            let serverData = {
                mobileNumber: transferMobile,
                identityId: item.id,
                dietIds: selectedDiets
            }

            if (checkedState) {
                delete serverData.dietIds
            } else {
                if (selectedDiets.length <= 0) {
                    return
                } else {
                    delete serverData.identityId
                }
            }


            try {
                setLoadingRow(true)
                const response = await transferUserData(serverData)
                if (response.data.err) {

                    notify(` کد${response.data.err.code} - ${response.data.err.details.messages[0]}`)
                    setLoadingRow(false)
                } else {
                    refetch()
                    setCheckedState(false)
                    setSelectedDiets([])
                    setLoadingRow(false)
                }

            } catch (error) {
                setLoadingRow(false)
                notify(`خطایی پیش آمده است`)
            }
        }
    }

    const onchangeChecked = (e: any) => {
        setCheckedState(!checkedState)
        if (checkedState) {
            setTitleState(true)
        } else {
            setTitleState(false)
        }

    }
    return (
        <div key={item.id} style={{
            display: "flex",
            flexDirection: "row",
            background: "#f5f5f5",
            marginTop: "20px",
            padding: "5px",
            borderRadius: "8px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)"
        }}>
            {loadingRow ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '5rem', width: "100%", minHeight: "572px" }}>
                <CircularProgress />
            </div> :
                <>
                    <div style={{ width: "10%", display: "flex",flexDirection:"column", alignItems: "center", justifyContent: "start" }}>
                    {mainIdentityId == item.id ?  <div style={{ fontFamily: "IranSans-Bold", color: "#ad1315",marginTop:"10px",border:"1px solid #f4dce5",background:"#fff", padding:"5px 10px 5px 10px",borderRadius:"5px" }}>
                        * پرونده اصلی  
                          
                        </div>: <div></div> }
                       
                 <div style={{margin:"auto"}}>
                 <FormGroup >
                            <FormControlLabel
                                control={<Switch checked={checkedState} onChange={(e) => onchangeChecked(e)} />}
                                label={checkedState ? ' ' : ' '}
                            />
                        </FormGroup>
                 </div>
                    </div>
                    <div style={{ width: "70%", padding: "5px", border: "1px solid #d2d2d2", borderTop: "none", borderBottom: "none" }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <div style={{ margin: "4px" }}>

                                <p style={{ color: "#01579b", marginTop: "5px", marginBottom: "5px", fontWeight: "900", fontSize: "18px" }}>Identity Info</p>

                                {item ? <IdentityInfo key={item.id} refetchChild={refetchChild}  relationTypes={relationTypes}  {...item} /> : ""}
                            </div>
                            <div style={{ margin: "4px" }}>
                                <p style={{ color: "#01579b", marginTop: "5px", marginBottom: "5px", fontWeight: "900", fontSize: "18px" }}>UserContact</p>

                                {item.userContacts ? item.userContacts.map((user: any) => (
                                    < UserContact key={user.id} {...user} />
                                )) : ""}
                            </div>
                        </div>
                        <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
                            {item.customers ? item.customers.map((user: any, index: number) => (
                                < CustomerInfo key={index} user={user} allDietTypes={allDietTypes} refetchChild={refetchChild} checkedState={checkedState} onSelectedDietsChange={handleSelectedDietsChange} />
                            )) : ""}
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "20%", padding: "20px" }}>

                        <form style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "90%",
                            height: "200px",
                            padding: "15px",
                            background: "#eeeee",
                            border: "1px solid #d2d2d2",
                            borderRadius: "8px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)"
                        }}
                            onSubmit={(e) => transfer(e)}>
                            <div>
                                <p style={{ fontFamily: "IranSans-Bold", color: "#424242" }}> {checkedState ?
                                    <div>انتقال کل پرونده  <span style={{ color: "#c62828" }}>*</span></div>
                                    :
                                    <div style={{ visibility: selectedDiets.length > 0 ? "visible" : "hidden" }}>  انتقال رژیم های انتخاب شده      <span style={{ color: "#c62828" }}></span></div>
                                }</p>
                            </div>
                            <TextField
                                label=" شماره موبایل"
                                value={transferMobile}
                                onChange={handleTransferInputChange}
                                variant="outlined"
                                fullWidth
                                error={Boolean(transferError)} 
                                helperText={transferError} 
                            />
                            <Button
                                onClick={(e) => transfer(e)}
                                fullWidth
                                disabled={checkDisablity()}
                                type="submit"
                                color="primary"
                                style={{ color: "#fff", marginTop: "30px" }}
                                variant="contained"
                            >
                                انتقال
                            </Button>
                        </form>

                        <form style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "auto",
                            background: "#eeeee",
                            border: "1px solid #d2d2d2",
                            borderRadius: "8px",
                            marginTop: "20px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)"
                        }}
                            onSubmit={(e) => archive(e, true)}>
                            <Button
                                onClick={(e) => archive(e, true)}
                                fullWidth
                                disabled={checkisArchived() || checkDisablityArchive()}
                                type="submit"
                                color="primary"
                                style={{ color: "#fff", margin: "10px", width: "90%" }}
                                variant="contained"
                            >
                                {titleState ? "      آرشیو رژیم" : "     آرشیو   "}


                            </Button>
                            <Button
                                onClick={(e) => archive(e, false)}
                                fullWidth
                                disabled={checkUnArchivable() || checkDisablityArchive()}
                                type="submit"
                                color="secondary"
                                style={{ color: "#fff", margin: "10px", width: "90%" }}
                                variant="contained"
                            >
                                {titleState ? "   خارج کردن از آرشیو رژیم" : "  خارج کردن از آرشیو   "}

                            </Button>

                            <Button
                                onClick={(e) => deleteSibProfileNumber(e)}
                                fullWidth
                                disabled={checkDisablityArchive()}
                                type="submit"
                                color="primary"
                                style={{ color: "#fff", margin: "10px", width: "90%" }}
                                variant="contained"
                            >
                                {titleState ? "  پاک کردن شماره پرونده رژیم " : " پاک کردن شماره پرونده"}                              </Button>
                        </form>

                    </div>
                </>
            }


        </div>

    )
}